import React from 'react';
import PropTypes from 'prop-types';
import { capitalize as _capitalize } from 'lodash';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';

import Styles from './ConfigsListItem.styles';

const VirtualDeviceConfigsListItem = ({
  browser,
  browserDisplay,
  browserVersionDisplay,
  url,
  version,
}) => (
  <div>
    <div className={Styles.url}>{url}</div>
    <div className={Styles.text}>{`${browserDisplay} ${browserVersionDisplay}`}</div>
    <div className={Styles.text}>{`${_capitalize(browser)} ${version}`}</div>
    <div className={Styles.icon}>
      <PlatformIcon name={browser} />
    </div>
  </div>
);

VirtualDeviceConfigsListItem.propTypes = {
  browser: PropTypes.string.isRequired,
  browserDisplay: PropTypes.string.isRequired,
  browserVersionDisplay: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
};

export default VirtualDeviceConfigsListItem;
